<template>
	<base-loader :show="isLoading"> </base-loader>
	<base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p class="text-white">{{ error }}</p>
	</base-modal>
	<base-modal :show="showConfirmDelete" title="Delete?" @close="showConfirmDelete = false">
		<template v-slot:buttons>
			<button class="btn btn-outline-danger" @click="confirmedDeletePost">Delete</button>
		</template>
	</base-modal>
	<base-modal :show="showPostForm" @close="close" title="Post to your league" >
		<div class="card text-info" style="background-color: #263238">
				<div class="card-body">
					<form v-if="isAuth" @submit.prevent="submitLeaguePostForm">
						<div class="form-outline text-start">
							<label for="title">Title</label>
							<input type="text" id="title" class="form-control" v-model.trim="title.val" />
						</div>
						<div class="form-outline mt-3 text-start">
							<label for="message">Message</label>
							<textarea class="form-control" id="message" rows="8" v-model.trim="message.val"></textarea>
						</div>
						<div class="d-grid mt-4">
							<button :disabled="postLoading" class="btn btn-outline-info btn-lg">
								<div v-show="postLoading">
									<i class="fa-solid fa-baseball fa-spin"></i>
									Posting...
								</div>
								<div v-show="!postLoading">Post</div>
							</button>
						</div>
					</form>
				</div>
			</div>
	</base-modal>
	<div class="row mt-5">
		<div class="col-md-8 mb-4">
			<div class="text-info" style="background-color: #212529">
				<div >
					<h1 v-if="!isAuth" class="d-inline">League Dugout Talk</h1>
					<h1 v-else class="d-inline">{{ truncLeagueName }} Dugout Talk</h1>
					<button class="btn btn-outline-info float-end mt-2 me-4" @click="showPostForm = true">Post</button>
				</div>
				<div v-if="isLoading" class="card ms-4 me-4 mt-4 mb-4" style="background-color: #263238" aria-hidden="true">
					<div class="card-body">
						<h5 class="card-header placeholder-glow text-info text-start ps-0 pb-3">
							<span class="placeholder col-3"></span>
						</h5>
						<p class="card-text placeholder-glow text-info text-start mt-3 mb-3">
							<span class="placeholder col-12"></span>
							<span class="placeholder col-12"></span>
							<span class="placeholder col-4"></span>
							<span class="placeholder col-6"></span>
						</p>
						<div class="card-footer text-white-50">
							<div class="d-flex justify-content-between placeholder-glow">
								<span class="placeholder col-1"></span>
								<span class="placeholder col-1"></span>
								<span class="placeholder col-1"></span>
							</div>
						</div>
					</div>
				</div>
				<div v-if="getAllPosts.length < 1 && !isLoading" class="mt-5">
					<h4>A swing and a miss..no dugout chatter</h4>
				</div>
				<div v-if="!isLoading" class="card-body">
					<div
						v-for="post in getAllPosts.slice().reverse()"
						:key="post"
						class="card text-body mb-3 text-start"
						style="background-color: #263238"
					>
						<div class="card-header text-info">
							<div class="d-inline">
								{{ post.byUser }}
							</div>
							<div v-if="post.byUserId === userId" class="d-inline float-end">
								<a
									role="button"
									@click="confirmDeletePost(post.id)"
									><i class="fa-solid fa-xmark"></i
								></a>
							</div>
							<h6 class="card-subtitle mb-2 text-white-50">
								<small v-if="post.byUserType === 'League Manager'">League Manager</small>
								<small v-else>{{ post.byUserDivision }} {{ post.byUserTeam }}</small>
							</h6>
						</div>
						<div class="card-body">
							<h5 class="card-title text-info">{{ post.title }}</h5>
							<p class="card-text text-info">
								{{ post.message }}
							</p>
						</div>
						<div class="card-footer text-white-50">
							<div>
								<small>{{ posted(post.timeStamp) }}</small>
							</div>
							<div class="d-flex justify-content-between">
								<a
									class="text-info"
									@click="likePost(post.id, post.likes, post.dislikes, post.likedBy, post.dislikedBy)"
									role="button"
								>
									<div v-if="post.likedBy.some((user) => user === userId)">
										<i class="fa-solid fa-fire text-danger"></i>
										{{ post.likes }}
									</div>
									<div v-else><i class="fa-solid fa-fire text-white-50"></i> {{ post.likes }}</div>
								</a>
								<a class="text-info" @click="showCommentsSection(post.id)" role="button">
									<i class="fas fa-comment-alt text-white-50"></i> {{ post.commentCount }}
								</a>
								<a
									class="text-info"
									@click="
										dislikePost(post.id, post.dislikes, post.likes, post.likedBy, post.dislikedBy)
									"
									role="button"
								>
									<div v-if="post.dislikedBy.some((user) => user === userId)">
										<i class="fa-solid fa-dumpster-fire text-danger"></i>
										{{ post.dislikes }}
									</div>
									<div v-else><i class="fa-solid fa-dumpster text-white-50"></i> {{ post.dislikes }}</div>
								</a>
							</div>
							<div v-if="showComments === post.id" class="">
								<form @submit.prevent="submitComment(post.id, post.commentCount)">
									<div class="form-outline mt-3 text-start">
										<label for="message">New Comment</label>
										<textarea
											class="form-control"
											id="message"
											rows="2"
											v-model.trim="comment.val"
										></textarea>
									</div>
									<button :disabled="postLoading" class="btn btn-block btn-info mt-2">
										<div v-show="postLoading">
											<i class="fa-solid fa-baseball fa-spin"></i>
											Posting...
										</div>
										<div v-show="!postLoading">Post</div>
									</button>
								</form>
								<div class="mt-3">
									<h5 v-if="!post.comments">No Comments</h5>
									<h5 v-else>Comments</h5>
									<div v-for="comments in post.comments" :key="comments">
										<p class="note note-info bg-dark">
											<span>
												<strong v-if="comments.byUserType === 'League Manager'">({{ comments.byUserType }}) {{ comments.byUser }} </strong>
												<strong v-else > ({{ comments.byUserTeam }}) {{ comments.byUser }} </strong>
											</span>
											<span class="float-end">
												<small> {{ posted(comments.timeStamp) }} </small>
											</span>
											<br />
											{{ comments.commentBody }}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isAuth" class="col-md-4">
			<div v-if="isAuth" class="card text-info" style="background-color: #263238">
				<div class="card-header">
					<h3>{{ truncLeagueName }}</h3>
				</div>
				<div>
					<div class="form-floating mt-3 mx-4">
						<select class="form-select" id="floatingSelectGrid" v-model="selectedDivision">
							<!-- <option value=""></option> -->
							<option v-for="div in getDivisions" :key="div" :value="{ id: div.id }">
								{{ div.division }}
							</option>
						</select>
						<label for="floatingSelectGrid">{{ truncLeagueName }} Divisions</label>
					</div>
					<div v-if="getAllSchedules.length > 0" class="form-floating mt-3 mx-4">
						<select class="form-select" id="floatingSelectGridSeason" v-model.trim="selectedSeasonInput">
							<option v-for="season in getAllSchedules" :key="season" :value="season">
								{{ season.season }}
							</option>
						</select>
						<label for="floatingSelectGridL">Season</label>
					</div>
				</div>
				<div v-if="getAllSchedules.length > 0" class="card-body overflow-auto">
					<table v-if="selectedSeasonInput" class="table text-info table-sm" style="background-color: #263238">
						<thead>
							<tr>
								<th scope="col-1">Week</th>
								<th>Home</th>
								<th></th>

								<th>Away</th>
							</tr>
						</thead>
						<tbody></tbody>
						<tbody v-for="games in getSchedule(selectedSeasonInput)" :key="games">
							<tr v-for="game in games.schedule" :key="game">
								<td>
									{{ game.week }}
								</td>
								<td>{{ game.home }}</td>
								<td>vs</td>
								<td>{{ game.away }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-else-if="selectedDivision" class="card-body">No Schedules</div>
				<div v-else class="card-body">Select a Division</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
moment().format();
export default {
	data() {
		return {
			user: null,
			title: {
				val: '',
				isValid: true,
			},
			message: {
				val: '',
				isValid: true,
			},
			comment: {
				val: '',
				isValid: true,
			},
			error: null,
			isLoading: false,
			postLoading: false,
			selectedSeasonInput: '',
			showComments: '',
			showConfirmDelete: false,
			postDeleteId: null,
			selectedDivision: '',
			showPostForm: false
		};
	},
	created() {
		this.loadPosts();
		this.loadTeams();
		this.loadSchedules();
		this.loadDivisions();
	},
	computed: {
		getAllPosts() {
			return this.$store.getters['boards/getLeaguePosts'];
		},
		getAllSchedules() {
			return this.$store.getters['leagues/allSchedules'];
		},
		isAuth() {
			return this.$store.getters.isAuthenticated;
		},
		userId() {
			return this.$store.getters.userId;
		},
		userType() {
			return this.$store.getters.userType;
		},
		userLeague() {
			return this.$store.getters.userLeague;
		},
		teams() {
			return this.$store.getters['teams/allTeams'];
		},
		getDivisions() {
			return this.$store.getters['leagues/allDivisions'];
		},
		truncLeagueName() {
			const league = this.$store.getters.userLeague;
			const index = league.indexOf('-');
			return league.slice(0, index);
		},
	},
	watch: {
		selectedDivision() {
			this.loadSchedules();
		},
	},
	methods: {
		async likePost(id, likes, dislikes, likedByArr, dislikedByArr) {
			if (this.isAuth) {
				var likeCount = likes;
				var dislikeCount = dislikes;
				const userId = this.$store.getters.userId;
				const likeExists = likedByArr.some((user) => user === userId);
				const dislikeExists = dislikedByArr.some((user) => user === userId);
				if (!likeExists && dislikeExists) {
					likedByArr.push(userId),
						(likeCount = likes + 1),
						(dislikeCount = dislikes - 1),
						(this.disableLike = true),
						(this.disableDislike = false);
				} else if (!likeExists) {
					likedByArr.push(userId), (likeCount = likes + 1);
				}
				const dislikedBy = dislikedByArr.filter((user) => user !== userId);
				const payload = {
					id: id,
					likes: likeCount,
					dislikes: dislikeCount,
					likedBy: likedByArr,
					dislikedBy: dislikedBy,
				};
				try {
					await this.$store.dispatch('boards/leaguePostLike', payload);
				} catch (err) {
					this.error = err.message || 'Try again.';
				}
				this.loadPosts();
			}
		},
		async dislikePost(id, dislikes, likes, likedByArr, dislikedByArr) {
			if (this.isAuth) {
				var dislikeCount = dislikes;
				var likeCount = likes;
				const userId = this.$store.getters.userId;
				const dislikeExists = dislikedByArr.some((user) => user === userId);
				const likeExists = likedByArr.some((user) => user === userId);
				if (!dislikeExists && likeExists) {
					dislikedByArr.push(userId), (dislikeCount = dislikes + 1), (likeCount = likes - 1);
					this.disableLike = false;
					this.disableDislike = true;
				} else if (!dislikeExists) {
					dislikedByArr.push(userId), (dislikeCount = dislikes + 1);
				}
				const likedBy = likedByArr.filter((user) => user !== userId);

				const payload = {
					id: id,
					dislikes: dislikeCount,
					likes: likeCount,
					likedBy: likedBy,
					dislikedBy: dislikedByArr,
				};

				try {
					await this.$store.dispatch('boards/leaguePostDisLike', payload);
				} catch (err) {
					this.error = err.message || 'Try again.';
				}
				this.loadPosts();
			}
		},
		postComments(postId) {
			const allPosts = this.$store.getters['boards/getGlobalPosts'];
			const post = allPosts.filter((post) => post.id === postId);
			return post.comments;
		},
		showCommentsSection(postId) {
			if (this.showComments === '') {
				this.showComments = postId;
			} else {
				this.showComments = '';
			}
		},
		async submitComment(postId, commentCount) {
			var commentCnt = commentCount;
			const payload = {
				postId: postId,
				commentBody: this.comment.val,
				timeStamp: moment().format(),
			};
			const payloadCount = {
				postId: postId,
				commentCount: commentCnt + 1,
			};

			try {
				this.postLoading = true;
				await this.$store.dispatch('boards/newLeagueComment', payload);
				await this.$store.dispatch('boards/leaguePostCommentCount', payloadCount);
				this.comment.val = '';
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
			this.loadPosts();
			setTimeout(() => {
				this.postLoading = false;
			}, 1000);
		},
		confirmDeletePost(id) {
			this.showConfirmDelete = true;
			this.postDeleteId = id;
		},
		confirmedDeletePost() {
			this.deleteThisPost(this.postDeleteId);
			this.showConfirmDelete = false;
		},
		deleteThisPost(id) {
			this.$store.dispatch('boards/deleteLeaguePost', { id: id });
		},
		getSchedule() {
			const allSeasons = this.$store.getters['leagues/allSchedules'];
			return allSeasons.filter((season) => season.season === this.selectedSeasonInput.season);
		},
		async submitLeaguePostForm() {
			const payload = {
				title: this.title.val,
				message: this.message.val,
				commentCount: 0,
				timeStamp: moment().format(),
			};

			try {
				this.postLoading = true;
				await this.$store.dispatch('boards/newLeaguePost', payload);
				this.title.val = '';
				this.message.val = '';
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
			this.loadPosts();
			setTimeout(() => {
				this.postLoading = false;
				this.showPostForm = false
			}, 1000);
		},
		posted(timeStamp) {
			return moment(timeStamp).fromNow();
		},
		async loadPosts() {
			try {
				await this.$store.dispatch('boards/fetchLeaguePosts');
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
		},
		async loadTeams() {
			this.isLoading = true;
			try {
				await this.$store.dispatch('teams/fetchTeams');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			setTimeout(() => {
				this.isLoading = false;
			}, 1500);
		},
		async loadSchedules() {
			// this.isLoading = true;
			const payload = {
				divisionId: this.selectedDivision.id,
			};
			try {
				await this.$store.dispatch('leagues/fetchSchedules', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			// setTimeout(() => {
			// 	this.isLoading = false;
			// }, 1500);
		},
		async loadDivisions() {
			this.isLoading = true;
			try {
				await this.$store.dispatch('leagues/fetchDivisions');
			} catch (error) {
				this.error = error.message;
			}
			setTimeout(() => {
				this.isLoading = false;
			}, 1500);
		},
		handleError() {
			this.error = null;
		},
		close() {
			this.showPostForm = false
		}
	},
};
</script>
